// utils/terminalGenerator.js
export function generateTerminalCommand() {
    const randomInt = (max, min = 0) => Math.floor(Math.random() * (max - min)) + min;
    const ipv4 = () => `192.168.${randomInt(256)}.${randomInt(256)}`;
    const cidr = () => `${ipv4()}/${[24, 16, 22, 30][randomInt(4)]}`;
    const ipv6 = () => `2001:db8::${randomInt(10000).toString(16)}`;
    const mac = () => Array(6).fill().map(() => randomInt(255).toString(16).padStart(2, '0')).join(':');
    const randomMs = () => (Math.random() * 100).toFixed(2);
    const hostname = () => ["openai", "alpha", "localhost", "node42", "gateway"][randomInt(5)];
    const domains = ["openai.com", "google.com", "github.com", "example.net", "cloudflare.com"];
    const randomDomain = domains[randomInt(domains.length)];
  
    const storage = () => `${randomInt(512, 8)}GB / ${randomInt(1, 8)}TB used`;
  
    const commands = [
      // Network
      [`$ netcalc analyze ${cidr()}`, `Usable Hosts: ${randomInt(2, 254)}`, `Subnet Mask: 255.255.255.0`, `Broadcast: ${ipv4()}`],
      [`$ ping ${randomDomain}`, `Reply from ${ipv4()}: time=${randomMs()} ms`, `TTL=${randomInt(255)}`],
      [`$ traceroute ${randomDomain}`, `1  ${ipv4()}  ${randomMs()} ms`, `2  ${ipv4()}  ${randomMs()} ms`, `3  ${ipv4()}  ${randomMs()} ms`],
      [`$ netstat -an`, `Proto  Local Address          Foreign Address        State`, `TCP    ${ipv4()}:443           ${ipv4()}:${randomInt(1000, 9000)}       ESTABLISHED`],
      [`$ nslookup ${randomDomain}`, `Server:  ${hostname()}`, `Address: ${ipv4()}`],
  
      // IPv6
      [`$ netcalc ipv6 ${ipv6()}/64`, `Range: ${ipv6()} - ${ipv6()}`, `Address Space: 2^64`],
      [`$ ip -6 addr`, `inet6 ${ipv6()} scope global dynamic`, `valid_lft forever preferred_lft forever`],
  
      // System
      [`$ top -n 1`, `CPU usage: ${randomInt(100)}%`, `Mem: ${randomInt(8192)}MB total, ${randomInt(4096)}MB used`],
      [`$ df -h`, `/dev/sda1  ${storage()}`, `/dev/sdb1  ${storage()}`],
      [`$ uptime`, `System uptime: ${randomInt(25)} days, ${randomInt(24)} hours, ${randomInt(60)} mins`],
  
      // Security
      [`$ fail2ban-client status`, `Status: active`, `Banned IPs: ${randomInt(20)}`],
      [`$ whoami`, `user: root`],
      [`$ sudo nmap -sn ${cidr()}`, `${ipv4()} is up`, `${ipv4()} is down`, `${ipv4()} is up`],
  
      // Identity
      [`$ whois ${ipv4()}`, `OrgName: Quantum Fiber`, `Country: US`, `NetRange: ${ipv4()} - ${ipv4()}`],
      [`$ arp -a`, `${hostname()}  (${ipv4()})  at ${mac()} [ether] on eth0`],
  
      // Dev fun
      [`$ curl -I https://${randomDomain}`, `HTTP/2 200`, `content-type: text/html`, `server: cloudflare`],
      [`$ git clone https://${randomDomain}/${hostname()}`, `Cloning into '${hostname()}'...`, `remote: Enumerating objects: ${randomInt(500)}...`],
      [`$ systemctl status ssh`, `Active: active (running) since Mon ${randomInt(10)}/Apr/2025`],
  
      // Smart noise
      [`$ echo $RANDOM`, `${randomInt(99999)}`],
      [`$ fortune | cowsay`, `"Beware of bugs in the above code; I have only proved it correct, not tried it."`, `                \\   ^__^`, `                 \\  (oo)\\_______`]
    ];
  
    return commands[randomInt(commands.length)];
  }
  